import { createGlobalStyle } from 'styled-components';
import { theme } from 'theme';

export const GlobalStyle = createGlobalStyle`
    html {
        height: 100%;
        font-size: 16px;
        line-height: 1.5;
    }

    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
  
    body {
        overflow-y: scroll;
        min-height: 100vh;
        font-family: ${theme.fontFamilyMain};
        background-color: ${theme.appBackgroundColour}
    }
    
    h1, h2, h3 {
        font-family: ${theme.fontFamilyHeader};
    }

    a {
        color: ${theme.linkColour};
        cursor: pointer;
        text-decoration: none;  
    }
    
    // hide number arrow inputs
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
`;
